import JobOrion from '../job-orion';

/**
 * Create the action
 */

const { thunk, request, success, error } = JobOrion.index((fetch) =>
    fetch.get('https://ontwikkelplatformnxt.nl/api/job')
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
